export default function clamp(number, min, max, shouldCeil) {
  const clamped = Math.max(min, Math.min(number, max));
  return shouldCeil ? Math.ceil(clamped) : clamped;
}
